import i18n from '@/utils/i18n';
import React from 'react';
import ScanIcon from '@assets/icons/scan.svg';
import { CircledIcon } from '@/components/circled-icon';
import { createStyles } from '@/contexts/theme-context';
import { ListItem } from '@/components/list-item';

interface Props {
  disabled?: boolean;
  onSelect: () => void;
  testID?: string;
}

export const PayByCheckFooter: React.FC<Props> = ({
  disabled,
  onSelect,
  testID,
}) => {
  const [styles] = useStyles();

  return (
    <ListItem
      disabled={disabled}
      item={{ title: i18n.t('pay_by_check'), value: '' }}
      listItemStyle={[styles.listItem, disabled ? styles.disabled : null]}
      onSelect={() => {
        if (!disabled) {
          onSelect();
        }
      }}
      renderLeftComponent={() => (
        <CircledIcon
          Icon={ScanIcon}
          iconHeight={20}
          iconWidth={20}
          size="small"
        />
      )}
      testID={testID}
    />
  );
};

const useStyles = createStyles((theme) => ({
  disabled: {
    opacity: 0.4,
  },
  listItem: {
    paddingHorizontal: theme.sk.spacing.spaceLarge,
  },
}));
